export default __webpack_public_path__ + "1341bce05a0fba97e6dbaca4ef674187.ogg";